module.exports = __webpack_public_path__ + "static/jnation-ea6e79fd1df1f25212372ba4aa428931.png";